const SUPPLIERS_BETA_FLAG_ENABLED = String(process.env.REACT_APP_SUPPLIERS_BETA_ENABLED || 'false')
  .trim()
  .toLowerCase() === 'true';
const BETA_AUTH_BYPASS_FLAG_ENABLED = String(process.env.REACT_APP_BETA_AUTH_BYPASS_ENABLED || 'false')
  .trim()
  .toLowerCase() === 'true';

function normalizeHostname(hostname) {
  return String(hostname || '')
    .trim()
    .toLowerCase()
    .replace(/^\[/, '')
    .replace(/\]$/, '');
}

function isSuppliersBetaHostname(hostname) {
  const normalized = normalizeHostname(hostname);
  return (
    normalized === 'localhost'
    || normalized === '127.0.0.1'
    || normalized === '::1'
    || normalized.startsWith('beta.')
  );
}

export const SUPPLIERS_BETA_ENABLED =
  SUPPLIERS_BETA_FLAG_ENABLED && isSuppliersBetaHostname(window.location.hostname);

export const BETA_AUTH_BYPASS_ENABLED =
  BETA_AUTH_BYPASS_FLAG_ENABLED && isSuppliersBetaHostname(window.location.hostname);
